var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4195 17.3819H18.0413V5.58042C18.0413 5.32458 17.8382 5.11719 17.5875 5.11719H11.2346C10.984 5.11719 10.7808 5.32458 10.7808 5.58042V17.3819H10.4027C10.2774 17.3819 10.1758 17.4856 10.1758 17.6135V17.9995H18.6464V17.6135C18.6464 17.4856 18.5448 17.3819 18.4195 17.3819ZM15.0161 17.3819H13.806V15.7606C13.806 15.6327 13.9076 15.529 14.0329 15.529H14.7892C14.9145 15.529 15.0161 15.6327 15.0161 15.7606V17.3819Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2437 17.3654H8.86555V1.47596C8.86555 1.21309 8.66238 1 8.41177 1H2.05882C1.8082 1 1.60504 1.21309 1.60504 1.47596V17.3654H1.22689C1.10159 17.3654 1 17.4719 1 17.6034V18H9.47059V17.6034C9.47059 17.4719 9.369 17.3654 9.2437 17.3654ZM5.84034 17.3654H4.63025V15.6995C4.63025 15.5681 4.73184 15.4615 4.85714 15.4615H5.61345C5.73875 15.4615 5.84034 15.5681 5.84034 15.6995V17.3654Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.11719,
    y: 9.11719,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.12109,
    y: 6.30078,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94141,
    y: 9.11719,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94141,
    y: 6.30078,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.12109,
    y: 3.40039,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94141,
    y: 3.40039,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.11719,
    y: 11.9414,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94141,
    y: 11.9414,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 9.61914,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3242,
    y: 6.80078,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1445,
    y: 9.61914,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1445,
    y: 6.80078,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 12.4414,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1445,
    y: 12.4414,
    width: 1.41176,
    height: 1.41176,
    fill: "CurrentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.d1459b25.svg";
export { ForwardRef as ReactComponent };